import { formatFetchedAt } from '../utils/formatting.js'

export default function AppHeader({
  latestSnapshot,
  snapshotCount,
  isUpdating,
  isUpdateDisabled,
  isMockData,
  theme,
  onUpdate,
  onOpenFilter,
  onMockDataChange,
  onThemeToggle,
}) {
  const isDarkTheme = theme === 'dark'

  return (
    <header className="app-header">
      <div className="title-group">
        <span className="eyebrow">ETF 代號 00981A</span>
        <h1>00981A 持股追蹤</h1>
      </div>

      <dl className="summary-grid" aria-label="ETF 資料摘要">
        <div>
          <dt>最新資料日期</dt>
          <dd>{latestSnapshot?.date ?? '--'}</dd>
        </div>
        <div>
          <dt>歷史紀錄天數</dt>
          <dd>{snapshotCount}</dd>
        </div>
        <div>
          <dt>最新資料筆數</dt>
          <dd>{latestSnapshot?.holdings.length ?? 0}</dd>
        </div>
        <div>
          <dt>最後更新時間</dt>
          <dd>{formatFetchedAt(latestSnapshot?.fetchedAt)}</dd>
        </div>
      </dl>

      <div className="header-actions">
        <button
          type="button"
          className="theme-toggle-button"
          aria-label={isDarkTheme ? '切換淺色模式' : '切換深色模式'}
          aria-pressed={isDarkTheme}
          onClick={onThemeToggle}
          title={isDarkTheme ? '切換淺色模式' : '切換深色模式'}
        >
          <span aria-hidden="true">{isDarkTheme ? '☀' : '☾'}</span>
        </button>
        <label className="mock-data-toggle">
          <input
            type="checkbox"
            checked={isMockData}
            onChange={(event) => onMockDataChange(event.target.checked)}
          />
          <span>模擬資料</span>
        </label>
        <button type="button" className="secondary-button" onClick={onOpenFilter}>
          篩選
        </button>
        <button
          type="button"
          className="primary-button"
          onClick={onUpdate}
          disabled={isUpdateDisabled}
          hidden
        >
          {isUpdating ? '更新中...' : '更新今日資料'}
        </button>
      </div>
    </header>
  )
}
